import React from 'react';
import { Search, X } from 'lucide-react';
import { FUNDING_DOCUMENT_CATEGORIES, FUNDING_DOCUMENT_ITEM_STATUSES } from '../../utils/funding/constants';

const FundingDocumentFilters = ({
  search,
  status,
  category,
  onSearchChange,
  onStatusChange,
  onCategoryChange,
}) => (
  <div className="flex flex-wrap items-center gap-3">
    <div className="relative min-w-[220px] flex-1">
      <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-[var(--fg-muted)]" />
      <input
        type="search"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search client, category, file..."
        className="w-full rounded-xl border border-[var(--fg-line)] bg-white py-2.5 pl-10 pr-9 text-sm outline-none ring-[var(--fg-accent)] focus:ring-2 dark:bg-[rgba(11,31,24,0.65)]"
      />
      {search ? (
        <button
          type="button"
          onClick={() => onSearchChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--fg-muted)] hover:text-[var(--fg-text)]"
          aria-label="Clear search"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>

    <select
      value={status}
      onChange={(event) => onStatusChange(event.target.value)}
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2.5 text-sm dark:bg-[rgba(11,31,24,0.65)]"
    >
      <option value="">All statuses</option>
      {FUNDING_DOCUMENT_ITEM_STATUSES.map((item) => (
        <option key={item} value={item}>{item}</option>
      ))}
    </select>

    <select
      value={category}
      onChange={(event) => onCategoryChange(event.target.value)}
      className="min-w-[180px] rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2.5 text-sm dark:bg-[rgba(11,31,24,0.65)]"
    >
      <option value="">All categories</option>
      {FUNDING_DOCUMENT_CATEGORIES.map((item) => (
        <option key={item} value={item}>{item}</option>
      ))}
    </select>
  </div>
);

export default FundingDocumentFilters;
